import { EInsightsTab, INSIGHTS_ACTIVE_TAB_KEY } from './constants';

export const getInitialInsightsTab = (): EInsightsTab =>
  (localStorage.getItem(INSIGHTS_ACTIVE_TAB_KEY) as EInsightsTab) || EInsightsTab.customer;
